import type { AppLanguage } from "../i18n/config";
import { buildLocalizedPath } from "../i18n/routing";
import { I18N_ROUTING } from "./site";

export const PAGES = {
  main: "/",
  pricing: "/pricing",
  billingSuccess: "/billing/success",
  billingCancelled: "/billing/cancelled",
  onboarding: "/onboarding",
  organisationInvitation: "/join/:token",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  events: "/events",
  newEvent: "/events/new",
  eventDetail: "/events/:eventId",
  contracts: "/contracts",
  finances: "/finances",
  profile: "/profile",
  settings: "/settings",
  organisationSettings: "/settings/organisation",
  settingsMembers: "/settings/members",
  settingsInvitations: "/settings/invitations",
  settingsVolunteerLink: "/settings/volunteer-link",
  settingsReferentials: "/settings/referentials",
  settingsFinance: "/settings/finance",
  settingsContractTemplates: "/settings/contract-templates",
  settingsPlan: "/settings/plan",
  volunteers: "/volunteers",
  newVolunteer: "/volunteers/new",
  volunteerLogin: "/volunteer-login",
  volunteerForgotPassword: "/volunteer-forgot-password",
  volunteerResetPassword: "/volunteer-reset-password",
  volunteerDashboard: "/volunteer",
  volunteerEventGuests: "/volunteer/events/:eventId/guests",
  volunteerSignup: "/volunteer-signup/:token",
  publicGuestList: "/guest-list/:token",
  cookiePolicy: "/cookie-policy",
  termsOfUse: "/terms-of-use",
  // Dev-only marketing capture routes, screenshotted by frontend/scripts/
  // (never registered in production builds).
  instaPostExport: "/insta-post/export",
  instaStoryExport: "/insta-story/export",
  instaCarouselExport: "/insta-carousel/export",
  instaAvatarExport: "/insta-avatar/export",
} as const;

export type PageKey = keyof typeof PAGES;

function resolvePageParams(
  pagePath: string,
  params?: Record<string, number | string>,
): string {
  if (!params) {
    return pagePath;
  }

  return Object.entries(params).reduce((resolvedPath, [key, value]) => {
    return resolvedPath.replace(`:${key}`, encodeURIComponent(String(value)));
  }, pagePath);
}

export function getPagePath(
  page: PageKey,
  language?: AppLanguage,
  params?: Record<string, number | string>,
): string {
  const pagePath = resolvePageParams(PAGES[page], params);

  if (I18N_ROUTING && language) {
    return buildLocalizedPath(language, pagePath);
  }

  return pagePath;
}
